import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import { standardBodyFont } from '../../themes'
import { translate } from '../../multilanguage'

const StyledFormControlLabelBase = withStyles(theme => ({
  label: {
    ...standardBodyFont(theme),
    ...props => props.style
  },
}))(FormControlLabel)

const FormControlLabelBase = props => {
  const {
    noTranslate,
    ...finalProps
  } = props
  return (
    <StyledFormControlLabelBase
      color='default'
      style={props.style}
      className={props.className}
      label={typeof props.label !== 'string' ? props.label : noTranslate ? props.label : translate(props.label)}
      control={props.control}
      value={props.value}
      {...finalProps}
    />
  )
}

FormControlLabelBase.propTypes = {  
  style: PropTypes.object,
  label: PropTypes.string.isRequired,
  control: PropTypes.node,
  value: PropTypes.string,
  noTranslate: PropTypes.bool,
  className: PropTypes.string,
}

export default FormControlLabelBase